import { cn } from "@/lib/utils";

export function NewsSkeletonLoader({ isDarkMode }: { isDarkMode: boolean }) {
  const cardBg = isDarkMode
    ? "bg-[#181818] border border-[#2c2c2c]/80 shadow-[0_26px_64px_-34px_rgba(0,0,0,0.65)]"
    : "bg-white/95 border-slate-200/80 shadow-[0_22px_58px_-30px_rgba(15,23,42,0.25)]";

  const imageBg = isDarkMode ? "bg-[#2c2c2c]" : "bg-slate-200/80";
  const barBg = isDarkMode ? "bg-[#303030]" : "bg-slate-200";

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 py-6">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className={cn(
            "relative flex h-full flex-col overflow-hidden rounded-3xl border backdrop-blur-sm animate-pulse",
            cardBg
          )}
        >
          <div className="p-3">
            <div
              className={cn(
                "aspect-[16/9] w-full rounded-2xl",
                imageBg
              )}
            />
          </div>

          <div
            className={cn(
              "mx-3 rounded-2xl border",
              isDarkMode ? "border-[#2c2c2c]" : "border-slate-200/70"
            )}
          ></div>

          <div className="flex flex-1 flex-col gap-4 px-4 pb-5 pt-4">
            <div className="flex w-full items-center gap-2">
              <div className={cn("h-3 w-20 rounded-full", barBg)} />
              <div className={cn("h-3 w-12 rounded-full", barBg)} />
            </div>

            <div className="space-y-3">
              <div className={cn("h-5 w-11/12 rounded-full", barBg)} />
              <div className={cn("h-5 w-4/5 rounded-full", barBg)} />
              <div className={cn("h-5 w-2/3 rounded-full", barBg)} />
            </div>

            <div className="space-y-2">
              <div className={cn("h-3 rounded-full", barBg)} />
              <div className={cn("h-3 w-5/6 rounded-full", barBg)} />
              <div className={cn("h-3 w-2/3 rounded-full", barBg)} />
            </div>

            <div className="flex items-center justify-between pt-2">
              <div className="flex gap-2">
                <div className={cn("h-9 w-20 rounded-full", barBg)} />
                <div className={cn("h-9 w-9 rounded-xl", barBg)} />
              </div>
              <div className={cn("h-9 w-9 rounded-xl", barBg)} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
